

export default function PublicPage(){
    return (
        <>
        <h1>Hi from the public page!</h1>
        </>
    )
}